import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedChevron = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="chevronDown" size="100%" color={stroke ?? color} />
);

export { LineRoundedChevron };
